import { styled } from '../../Styles/stitches.config'
import { StyledSVG } from '../../Atoms/SVG/styles'
import { StyledText } from '../../Atoms/Text/styles'

export const StyledStartIcon = styled('div', {
    display: 'inline-block',
    [`& ${StyledSVG}`]: {
        size: 14,
        color: '$primary600',
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    },
})

export const StyledEndIcon = styled('div', {
    display: 'inline-block',
    [`& ${StyledSVG}`]: {
        size: 14,
        color: '$error600',
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    },
})

export const StyledIcon = styled('div', {
    display: 'inline-block',
    [`& ${StyledSVG}`]: {
        mr: '$3',
        size: 16,
        position: 'relative',
        top: 2,
    },
})

export const StyledAttachedFilesField = styled('button', {
    bgc: 'transparent',
    position: 'relative',
    border: '1px dashed $neutral300',
    br: '$2',
    color: '$neutral300',
    p: 'calc($3 - ($1 / 2)) $3',
    w: '100%',
    textAlign: 'left',
    transition: '$default',

    '&:hover': {
        bgc: '$neutral100',
        bc: '$neutral100',
    },

    variants: {
        active: {
            true: {
                border: 'none',
                br: 0,
                borderBottom: '1px solid $neutral200',
                bgc: 'transparent',
                color: '$neutral400',

                [`& ${StyledText}`]: {
                    fontWeight: 400,
                    ml: '$2',
                },
            },
        },
    },
})
